import { jsx as _jsx } from "react/jsx-runtime";
import { Button as AntDButton } from "antd";
import "./button.scss";
/**
 * Primary UI component for user interaction
 * Supports different styles, sizes, shapes, and icons.
 * Note: not all antd props are supported yet, but this will likely change soon.
 */
export const Button = ({ type, icon, shape = "default", size = "middle", disabled, loading, prefixCls, className = "te-btn", ghost, danger, block, children, onClick }) => {
    return (_jsx(AntDButton, { "data-testid": "btn", type: type, icon: icon, shape: shape, size: size, disabled: disabled, loading: loading, prefixCls: prefixCls, className: className, ghost: ghost, danger: danger, block: block, onClick: onClick, children: children }));
};
